import { Button } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux';
import AccountTreeIconOutlined from '@mui/icons-material/AccountTreeOutlined';

const VisualWorkflowButton = ({handleOnClick}) => {
    const screen = useSelector(state => state?.treeData?.currentScreen);
    const templateHeader = useSelector(state => state.treeData.workflow.rightTree.tree.templateHeader);
    const disabled = templateHeader?.length === 0;

  return (
    screen === "workflow" && <>
    <Button 
    size="small"
    variant="outlined"
    className="margin-right-4"
    disabled={disabled}
    onClick={handleOnClick}>
        <AccountTreeIconOutlined
          fontSize="small"
          className="margin-right-4"
          style={{ opacity: disabled ? 0.5 : 1 }}
        />
    </Button>
    </>
  )
}

export default VisualWorkflowButton;